var map = {
	"./gg0.png": "hWqY",
	"./gg1.png": "OHsg"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uQkD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index ^\.\/gg.*\.png$
// module id = uQkD
// module chunks = 3